class StockIndicator extends HTMLElement {
  connectedCallback() {
    // Listen for the `variant-change` event
    document.addEventListener('variant-change', (event) => {
      this.render(Number(event?.detail?.variant?.id));
    });
  }

  render(selectedVariantId) {
    if (typeof selectedVariantId !== 'number') return;

    this.querySelectorAll('[data-stock-indicator]')?.forEach((stockVariant) => {
      Number(stockVariant.dataset.stockIndicator) === selectedVariantId
        ? stockVariant.classList.remove('hidden')
        : stockVariant.classList.add('hidden');
    });
  }
}

// Define the custom element
customElements.define('stock-indicator', StockIndicator);
